module.exports = __webpack_public_path__ + "media/images/subject_img/SPORTS SCIENCE-454b21176e9b0c7355917565de151ee0.jpg";